export default {
  name: 'marking--mrkPackageType',
};